var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.5,
    height: 108.213,
    viewBox: "0 0 207.5 108.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.8,383.593a31.622,31.622,0,1,1-31.622,31.62A31.621,31.621,0,0,1,428.8,383.593Zm0,55.511a23.89,23.89,0,1,0-23.889-23.891A23.89,23.89,0,0,0,428.8,439.1Z",
    transform: "translate(-397.18 -383.593)",
    fill: "#26242d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.447 49.077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.848,387.086a26.174,26.174,0,1,1-26.175,26.173A26.174,26.174,0,0,1,426.848,387.086Zm0,46.295a20.121,20.121,0,1,0-20.12-20.122A20.121,20.121,0,0,0,426.848,433.381Z",
    transform: "translate(-400.673 -387.086)",
    fill: "#26242d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.576 42.289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.629,382.733a32.962,32.962,0,1,1-32.961,32.961A32.962,32.962,0,0,1,337.629,382.733Zm0,54.35a21.389,21.389,0,1,0-21.388-21.389A21.389,21.389,0,0,0,337.629,437.084Z",
    transform: "translate(-304.668 -382.733)",
    fill: "#26242d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.5 49.214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.147,387.174a26.038,26.038,0,1,1-26.038,26.036A26.036,26.036,0,0,1,335.147,387.174Zm0,44.193a18.156,18.156,0,1,0-18.155-18.157A18.156,18.156,0,0,0,335.147,431.367Z",
    transform: "translate(-309.109 -387.174)",
    fill: "#26242d"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.242 65.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.2,407.235a9.379,9.379,0,1,1-9.379-9.378A9.381,9.381,0,0,1,430.2,407.235Z",
    transform: "translate(-411.444 -397.857)",
    fill: "#26242d"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.643 38.243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.433,384.641l-26.3,39.274-6.334-4.5,26.3-39.274Z",
    transform: "translate(-397.802 -380.138)",
    fill: "#26242d"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.252 37.133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.521,391.894a6.072,6.072,0,0,1-8.617,1.291c-9.666-7.079-26.412-7.547-22.364-9.673a35.607,35.607,0,0,1,35.776,1.539Z",
    transform: "translate(-396.921 -379.426)",
    fill: "#00ad7c"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.101 65.872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.077,416.616H332.925l-12.863-18.759h71.015a9.4,9.4,0,0,1,9.379,9.378v0A9.406,9.406,0,0,1,391.077,416.616Z",
    transform: "translate(-320.062 -397.857)",
    fill: "#26242d"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 10.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.6,371.232c-11.378.331-24.274,1.771-36.571,5.83a5.358,5.358,0,0,0-3.067,2.651l-2.124,4.129a7.141,7.141,0,0,1-5.7,2.838l-12.662-.023-12.018-15.788a24.848,24.848,0,0,0-26.376-7.415l-23.6,8.985,19.11,46.635a34.435,34.435,0,0,0,31.863,21.378h36.376L406.3,423.674c15.61-33.536,26.605-38.924,49.908-41.466l-4.892-7.472A7.758,7.758,0,0,0,444.6,371.232Z",
    transform: "translate(-322.482 -362.261)",
    fill: "#00ad7c"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.788 22.601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.1,376.137l-5.908-6.03h9.861c.058.081.125.156.181.24l3.789,5.79Z",
    transform: "translate(-323.189 -370.107)",
    fill: "#ebedf2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.641 22.108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.394,419.462l3.535,16.778H402.553a34.435,34.435,0,0,1-31.863-21.378l-18.469-45.071S453.549,388.5,435.394,419.462Z",
    transform: "translate(-352.221 -369.791)",
    fill: "#00ad7c"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.154 23.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.938,382.005a7.141,7.141,0,0,0,5.7-2.838l2.122-4.126a5.326,5.326,0,0,1,3.073-2.649c2.035-.66,4.085-1.238,6.142-1.773l-.055.664a20.8,20.8,0,0,1-11.032,16.708h0a13.305,13.305,0,0,1-17.008-4l-1.442-2.008Z",
    transform: "translate(-349.437 -370.619)",
    fill: "#26242d"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.443 36.268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.73,427.235l.061-27.424c.828-17.217-68.83-20.939-68.83-20.939l12.666,30.911c4.884,12.135,23.934,17.452,37.014,17.452Z",
    transform: "translate(-359.96 -378.872)",
    fill: "#26242d"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.504 61.06)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.26,394.771c1.037.565,2.036,1.137,2.953,1.72v19.881H366.26Z",
    transform: "translate(-366.26 -394.771)",
    fill: "#333334"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.897 57.172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.575,400.781c21.665-21.665,23.886,4.6,23.764,7.125l-.061,11.831H389.189a32.034,32.034,0,0,1-29.227-18.955Z",
    transform: "translate(-359.962 -392.277)",
    fill: "#26242d"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.737,391.839l-15.79-3.9A2.836,2.836,0,0,1,392.9,385.1c.742-12.35,7.421-21.2,15.978-29.488l16.657,1.258a1.918,1.918,0,0,1,1.169,3.31l-18.6,17.5c-3.82,4.811-1.241,8.525,3.661,11.842A1.285,1.285,0,0,1,410.737,391.839Z",
    transform: "translate(-392.892 -355.613)",
    fill: "#00ad7c"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.506 22.723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.67,370.185h8.865l-3.579,4.772a7.759,7.759,0,0,1-6.209,3.106h0a2.5,2.5,0,0,1-.153-.982A35.473,35.473,0,0,1,409.67,370.185Z",
    transform: "translate(-408.591 -370.185)",
    fill: "#ebedf2"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.495,355.613l14.65,1.107-21.222,18.651-7.6.494C397.978,368.046,403.233,361.676,409.495,355.613Z",
    transform: "translate(-395.319 -355.613)",
    fill: "#ebedf2"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.319 0.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.522,372.516l15.359-16.544,7.263.549-21.222,18.651-7.6.494q.412-1.212.908-2.38Z",
    transform: "translate(-395.319 -355.971)",
    fill: "#ebedf2"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.458 71.834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.711,405.1a3.417,3.417,0,1,1-3.417-3.416A3.417,3.417,0,0,1,368.711,405.1Z",
    transform: "translate(-361.878 -401.68)",
    fill: "#fff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(98.289 47.315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.157,390.768a4.812,4.812,0,1,1-4.812-4.812A4.813,4.813,0,0,1,378.157,390.768Z",
    transform: "translate(-368.533 -385.956)",
    fill: "#fff"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.475 18.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.936,374.936l-10.611-.987a3.3,3.3,0,0,1-2.985-3.594h0a3.3,3.3,0,0,1,3.594-2.985l10.613.986a3.3,3.3,0,0,1,2.983,3.6h0A3.3,3.3,0,0,1,407.936,374.936Z",
    transform: "translate(-394.326 -367.356)",
    fill: "#26242d"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.369 47.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.605,392.582a1.56,1.56,0,0,0,.331-3.084l-14.365-3.13a1.56,1.56,0,1,0-.663,3.048l14.363,3.13A1.538,1.538,0,0,0,398.605,392.582Z",
    transform: "translate(-382.68 -386.332)",
    fill: "#fff"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.859 42.068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.038,390.143a1.56,1.56,0,0,0,.345-3.08l-19.443-4.43a1.558,1.558,0,0,0-.692,3.039l19.443,4.43A1.48,1.48,0,0,0,402.038,390.143Z",
    transform: "translate(-381.034 -382.591)",
    fill: "#fff"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.036 53.225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.937,395.019a1.56,1.56,0,0,0,.331-3.084l-9.9-2.152a1.56,1.56,0,1,0-.664,3.049l9.9,2.152A1.552,1.552,0,0,0,395.937,395.019Z",
    transform: "translate(-384.471 -389.746)",
    fill: "#fff"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.05 58.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.137,397.449a1.558,1.558,0,0,0,.317-3.084l-5.7-1.191a1.559,1.559,0,1,0-.636,3.052l5.7,1.191A1.491,1.491,0,0,0,393.137,397.449Z",
    transform: "translate(-385.878 -393.139)",
    fill: "#fff"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.935 61.266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.014,407.275a8.65,8.65,0,1,0,4.09-11.53A8.65,8.65,0,0,0,373.014,407.275Z",
    transform: "translate(-372.171 -394.903)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.464 1.465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.811,406.121a7.186,7.186,0,1,0,3.4-9.579A7.187,7.187,0,0,0,373.811,406.121Z",
    transform: "translate(-373.111 -395.842)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.179 3.984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.1,400.123a1.863,1.863,0,1,0,.881-2.484A1.865,1.865,0,0,0,377.1,400.123Z",
    transform: "translate(-376.916 -397.458)",
    fill: "#fff"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.111 61.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.088,407.5a34.784,34.784,0,0,0,13.381-6.373,2,2,0,0,0,.943-2.66l-.973-2.043a2,2,0,0,0-2.66-.943L367.4,401.848a2,2,0,0,0-.943,2.662l.973,2.043A2,2,0,0,0,370.088,407.5Z",
    transform: "translate(-366.26 -395.282)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.697 2.183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.742,398.489a1.264,1.264,0,1,0,.6-1.684A1.265,1.265,0,0,0,367.742,398.489Z",
    transform: "translate(-367.62 -396.682)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.983 7.762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.256,402.067a1.264,1.264,0,1,0,.6-1.684A1.263,1.263,0,0,0,375.256,402.067Z",
    transform: "translate(-375.132 -400.26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.887 4.035)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.455,
    height: 2.529,
    transform: "translate(0 2.775) rotate(-25.467)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.0615ff0b8722c0520817e977e0a8fb48.svg";
export { ForwardRef as ReactComponent };